<template>
  <div>
    <div class="top_side_bar">
      <a href="/">
        <img :src="loginLogoUrl" style="width:129px;" />
      </a>
    </div>
    <div v-if="user.userType != '00'" class="menu">
      <!--                        <el-popover placement="top-start" width="200" :disabled="isShowPopov">-->
      <!--                            <el-button slot="reference" @click="topMenuClick('/index')">首页</el-button>-->
      <!--                        </el-popover>-->

      <el-popover
        placement="bottom-start"
        trigger="hover"
        :close-delay="hTime"
        :disabled="!menu.hasOwnProperty('children')"
        v-for="(menu, index) in menus"
        v-show="!menu.hidden"
        @click.native="handleJumpMenu(menu)"
        :key="index"
      >
        <div style="width: 450px">
          <!--                    <div v-for="(item,index) in menu.children" :class="index == system.length-1? 'bottom_menu_row':'menu_row'">-->
          <div
            v-for="(item, index) in menu.children"
            :key="index"
            class="menu_row"
          >
            <div class="menu_til">
              <img class="icon round-pic" width="50px" v-if="item.meta.title == 'Amazon'" src="data:image/png;base64,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" alt="" srcset="">
              <svg
                v-else-if="item.meta.title == 'Shopify'"
                class="icon round-pic"
                aria-hidden="true"
              >
                <use xlink:href="#zw_icon-logo-shopify"></use>
              </svg>
              <svg
                v-else-if="item.meta.title == 'Shopline'"
                class="icon round-pic"
                aria-hidden="true"
              >
                <use xlink:href="#zw_icon-logo-shopline"></use>
              </svg>
              <svg
                v-else-if="item.meta.title == '店匠'"
                class="icon round-pic"
                aria-hidden="true"
              >
                <use xlink:href="#zw_icon-logo-dianjiang"></use>
              </svg>
              <span v-else>{{ item.meta.title }}</span>
            </div>
            <div class="menu_leaf_body">
              <div
                class="leaf_menu"
                v-for="(leaf, index) in item.children"
                v-show="!leaf.hidden"
                :key="index"
              >
                <!-- <router-link
                  class="r_link"
                  :to="resolvePath(menu.path, item.path, leaf.path)"
                  ><span :title="leaf.meta.title">{{
                    leaf.meta.title.length > 8
                      ? leaf.meta.title.substring(0, 8) + "..."
                      : leaf.meta.title
                  }}</span>
                </router-link> -->
                <!-- 新页面打开 -->
                <a
                  v-if="['createBatchNew', 'designerNew', 'designerOther', 'createBatch', 'tool'].includes(leaf.path)"
                  class="r_link"
                  :href="getFullPath(menu.path, item.path, leaf.path)"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span :title="leaf.meta.title">
                    {{ leaf.meta.title.length > 8 ? leaf.meta.title.substring(0, 8) + "..." : leaf.meta.title }}
                  </span>
                </a>
                <!-- 当前页面打开 -->
                <router-link
                  v-else
                  class="r_link"
                  :to="resolvePath(menu.path, item.path, leaf.path)"
                >
                  <span :title="leaf.meta.title">
                    {{ leaf.meta.title.length > 8 ? leaf.meta.title.substring(0, 8) + "..." : leaf.meta.title }}
                  </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <el-button slot="reference" @click="topMenuClick(menu.path)">{{
          menu.meta.title
        }}</el-button>
      </el-popover>
    </div>
    <div class="right-login-info">
      <div
        v-if="user.userType != '00'"
        onmouseover="setBackground(this,'#8071c9')"
        onmouseout="setBackground(this,'#4934b2')"
        @click="handleJump('/order/myOrder/shopCart')"
        class="cart"
      >
        <svg-icon style="width:23px;" icon-class="cart"></svg-icon>
        <div class="cart-number">{{ stat.cartCount }}</div>
      </div>
      <!-- <div
        v-if="false"
        onmouseover="setBackground(this,'#8071c9')"
        onmouseout="setBackground(this,'#4934b2')"
        @click="handleJump('/order/myOrder/shopCart')"
        class="cart"
      >
        <svg-icon style="width:21px;" icon-class="notice"></svg-icon>
        <div v-if="false" class="cart-number">{{ stat.messageCount }}</div>
      </div> -->
      <div
        class="plat-nav-dropdown-btn nav-bm-user-btn"
        @mouseenter="handleRefreshUser"
      >
        <div class="common-topbar-user-info">
          <div class="common-topbar-user-image-wrapper">
            <img
              v-if="user.userType != '00'"
              style="width:40px;margin: 0 6px 0 0;"
              :src="getImage"
            />
            {{ user.nickName ? user.nickName : name }}
          </div>
        </div>
        <LoginBar :userData="user" ref="loginBar" custom="white"></LoginBar>
      </div>
    </div>
    <symbol id="zw_icon-logo-shopify" viewBox="0 0 3072 1024"
      ><path
        d="M646.741333 169.898667c7.125333 0 13.141333 1.493333 18.389334 4.864a82.389333 82.389333 0 0 0-23.978667 18.688c-19.456 20.949333-34.432 53.162667-40.405333 84.608-18.730667 5.589333-36.650667 11.221333-53.546667 16.426666 11.264-49.365333 52.437333-123.093333 99.541333-124.586666m41.898667 80.853333c-20.565333 6.314667-42.666667 13.056-65.066667 20.181333 6.314667-23.893333 18.346667-47.914667 32.938667-63.573333 5.589333-5.973333 13.056-12.373333 22.058667-16.128 8.576 17.578667 10.069333 42.666667 10.069333 59.52m50.56-15.744c-9.002667 2.602667-19.072 6.016-30.336 9.386667-0.384-15.36-2.261333-37.077333-9.344-55.808 23.594667 4.48 34.816 30.72 39.68 46.421333m146.645333 36.266667c-0.341333-3.328-3.328-4.821333-5.546666-5.205334a2136.064 2136.064 0 0 0-47.189334-0.768s-37.802667-36.650667-41.514666-40.405333c-3.754667-3.712-10.837333-2.56-13.866667-1.877333l-19.072 6.016a122.453333 122.453333 0 0 0-9.002667-22.101334c-13.44-25.813333-32.896-39.253333-56.874666-39.253333-1.493333 0-3.370667 0-4.864 0.341333a49.408 49.408 0 0 0-41.557334-18.688c-30.677333 0.725333-60.928 22.784-86.016 62.464-17.621333 27.733333-30.72 62.506667-34.432 89.429334-35.2 10.88-59.861333 18.346667-60.245333 18.773333-17.621333 5.546667-18.389333 5.973333-20.608 22.784-1.877333 12.373333-48.256 371.968-48.256 371.968l389.504 67.413333 168.832-41.984S886.229333 274.346667 885.845333 271.274667"
        fill="#95BF47"
      ></path
      ><path
        d="M880.298667 266.069333c-2.261333-0.384-47.146667-0.768-47.146667-0.768s-37.802667-36.650667-41.557333-40.405333a7.424 7.424 0 0 0-5.248-2.261333v559.488l168.789333-41.941334S886.272 274.688 885.888 271.36a6.698667 6.698667 0 0 0-5.589333-5.248"
        fill="#5E8E3E"
      ></path
      ><path
        d="M692.778667 352.896l-19.456 73.344s-21.717333-10.112-47.872-8.234667c-38.229333 2.261333-38.570667 26.197333-38.229334 32.554667 2.261333 32.938667 88.362667 40.064 93.226667 116.778667 3.754667 60.629333-32.213333 101.76-83.84 105.130666-62.122667 3.754667-96.170667-32.554667-96.170667-32.554666l13.098667-55.765334s34.389333 25.813333 61.738667 24.362667a24.192 24.192 0 0 0 23.594666-26.24c-2.645333-42.666667-72.96-40.405333-77.482666-110.378667-3.712-59.136 35.2-118.997333 120.874666-124.586666 33.706667-3.029333 50.517333 5.589333 50.517334 5.589333"
        fill="#FFFFFF"
      ></path
      ><path
        d="M2592.298667 400.426667s-48.256 121.6-69.973334 187.861333h-1.109333c-1.493333-21.333333-19.072-187.861333-19.072-187.861333h-80.853333l46.421333 251.093333a17.749333 17.749333 0 0 1-1.493333 12.757333 133.674667 133.674667 0 0 1-41.941334 46.378667 168.021333 168.021333 0 0 1-43.776 21.717333l21.333334 65.450667c15.701333-3.328 47.914667-16.042667 75.605333-41.856 35.2-32.938667 67.754667-83.84 101.034667-153.088l94.293333-202.453333h-80.469333z m-185.6-0.725334h-53.504l2.56-12.714666c4.565333-26.24 20.266667-49.792 45.653333-49.792 13.909333 0 24.746667 3.712 24.746667 3.712l14.933333-60.202667s-13.397333-6.741333-41.856-6.741333c-27.306667 0-54.656 7.850667-75.605333 25.813333-26.197333 22.442667-38.528 54.613333-44.928 87.210667l-2.218667 12.714666h-35.925333l-11.221334 57.984h35.925334l-40.789334 215.893334h77.098667l40.789333-215.893334h53.12l11.221334-58.026666z m-325.546667 273.92h77.056l52.437333-273.194666h-77.866666l-51.626667 273.194666z m107.776-389.973333a43.946667 43.946667 0 0 0-44.16 44.928c0 22.826667 14.592 38.570667 36.266667 38.570667h1.152c23.893333 0 44.885333-16.128 45.226666-44.928 0-22.442667-14.933333-38.528-38.485333-38.528z m-263.466667 337.578667c-20.224 0-31.786667-11.221333-31.786666-11.221334l12.714666-72.234666c8.96-47.914667 34.048-80.085333 61.013334-80.085334 23.552 0 30.634667 21.717333 30.634666 42.666667 0 49.749333-29.525333 120.874667-72.576 120.874667z m73.728-227.157334c-52.053333 0-81.578667 45.653333-81.578666 45.653334h-1.109334l4.48-41.514667h-68.096c-3.413333 28.032-9.386667 70.357333-15.701333 102.144l-53.546667 282.154667h77.098667l21.333333-114.133334h1.493334s15.701333 10.112 45.226666 10.112c90.581333 0 149.717333-92.8 149.717334-186.752 0.384-51.285333-22.784-97.706667-79.36-97.706666z m-339.797333 226.005334c-26.197333 0-37.418667-22.4-37.418667-50.133334 0-44.16 22.826667-116.352 64.725334-116.352 27.306667 0 36.266667 23.552 36.266666 46.378667 0 47.530667-22.784 120.106667-63.573333 120.106667z m38.186667-226.005334c-92.842667 0-154.197333 83.84-154.197334 177.365334 0 59.904 37.034667 107.776 106.24 107.776 90.965333 0 152.704-81.536 152.704-177.365334-0.341333-55.04-32.896-107.776-104.746666-107.776z m-237.653334 0c-34.048 0-61.013333 16.085333-81.536 40.789334l-1.152-0.426667 29.568-154.88h-77.098666l-74.837334 394.069333h77.098667l25.813333-134.698666c10.112-50.901333 36.266667-82.346667 61.013334-82.346667 17.194667 0 23.893333 11.605333 23.893333 28.416 0 10.496-1.109333 23.594667-3.285333 34.090667l-29.226667 154.154666h77.098667l30.293333-159.402666c3.370667-16.853333 5.546667-37.034667 5.546667-50.176 0-43.008-23.168-69.589333-63.189334-69.589334z m-276.181333 115.285334c-19.456-10.496-29.525333-19.498667-29.525333-31.829334 0-15.786667 13.824-25.813333 35.925333-25.813333 25.429333 0 47.914667 10.453333 47.914667 10.453333l17.92-54.613333s-16.426667-12.714667-64.725334-12.714667c-67.413333 0-114.133333 38.528-114.133333 92.8 0 30.677333 21.717333 54.186667 50.901333 71.082667 23.552 13.482667 31.829333 22.826667 31.829334 37.077333 0 14.506667-11.648 26.154667-33.706667 26.154667-32.554667 0-63.274667-16.810667-63.274667-16.810667l-19.072 54.613334s28.458667 19.072 75.946667 19.072c69.248 0 119.04-34.005333 119.04-95.402667 0.384-33.322667-24.746667-56.874667-55.04-74.069333z"
        fill="#000000"
      ></path
    ></symbol>
    <symbol id="zw_icon-logo-shopline" viewBox="0 0 3072 1024"
      ><path
        d="M540.074667 568.704c-8.448-8.533333-29.184-18.176-62.634667-28.885333-66.304-22.016-124.117333-52.48-123.904-118.357334 0.213333-63.232 58.24-105.557333 139.52-105.301333 83.968 0.256 138.538667 49.322667 138.325333 117.333333l-77.610666-0.256c0.128-32.426667-19.968-54.784-61.994667-54.912-40.874667-0.128-60.586667 19.456-60.714667 43.904 0 24.448 25.941333 39.936 74.752 54.954667 82.816 25.258667 125.781333 60.458667 125.568 122.624-0.213333 66.432-54.570667 104.96-137.386666 104.746667a210.346667 210.346667 0 0 1-72.789334-13.525334C374.485333 673.365333 341.162667 636.586667 341.333333 579.754667l78.08 0.256c-0.128 45.653333 30.08 62.72 74.752 62.933333 39.808 0.128 59.008-18.432 59.093334-42.88a43.434667 43.434667 0 0 0-13.184-31.36M929.706667 538.581333l-152.021334-0.512-0.512 162.133334-78.08-0.298667 1.194667-377.770667 78.08 0.256-0.512 153.002667 151.978667 0.512 0.512-153.045333 78.08 0.256-1.237334 377.770666-78.08-0.256zM1551.914667 506.581333l69.632 0.213334c44.629333 0.128 63.274667-23.168 63.402666-56.106667 0.085333-32.938667-18.389333-62.250667-63.018666-62.293333l-69.589334-0.298667-0.426666 118.485333z m-0.64 196.053334l-78.08-0.256 1.237333-377.770667 147.712 0.512c89.216 0.256 141.653333 53.034667 141.44 125.312-0.256 72.789333-52.992 119.338667-142.250667 119.082667l-69.589333-0.256-0.469333 133.376zM1812.906667 324.693333l30.890666 0.128-1.152 348.373334 170.837334 0.554666-0.085334 26.752-201.685333-0.64zM2058.368 325.546667l30.890667 0.042666-1.28 375.125334-30.848-0.085334zM2150.613333 325.802667l36.181334 0.128 172.885333 258.346666 46.976 75.776h2.901333c-2.133333-37.034667-4.394667-74.666667-4.266666-111.146666l0.682666-222.293334 33.28 0.128-1.28 375.04-36.096-0.042666-172.330666-258.858667-47.573334-75.306667h-2.901333c1.621333 36.010667 4.437333 71.04 4.309333 108.586667l-0.725333 224.853333-33.237333-0.085333 1.194666-375.125333zM1423.189333 513.28c-0.341333 107.733333-83.242667 194.816-185.173333 194.474667-101.973333-0.341333-184.234667-87.893333-183.893333-195.626667 0.341333-107.690667 83.2-194.773333 185.130666-194.432 101.930667 0.341333 184.277333 87.893333 183.893334 195.626667"
        fill="#333F48"
      ></path
      ><path
        d="M1223.381333 446.634667a25.173333 25.173333 0 1 1-0.213333 50.346666 25.173333 25.173333 0 0 1 0.213333-50.346666z m125.952 195.456a178.773333 178.773333 0 0 0 54.4-128.853334 181.162667 181.162667 0 0 0-4.992-42.24L1254.656 397.226667l-102.869333 31.189333-0.768 13.482667 23.466666 96.896 174.848 103.296zM1343.104 647.765333l-165.973333-98.005333 2.688 10.752 111.317333 117.546667c19.072-6.741333 36.693333-17.066667 51.968-30.293334M1183.616 576.298667l26.24 108.032c9.173333 1.706667 18.56 2.816 28.202667 2.858666 15.445333 0.042667 30.336-2.218667 44.544-6.357333l-98.986667-104.533333z"
        fill="#FFFFFF"
      ></path
      ><path
        d="M2537.258667 518.656l193.408 0.384v-26.24l-193.322667-0.426667 0.426667-136.832 192.853333 0.426667V329.813333l-225.621333-0.554666-1.194667 375.125333 226.56 0.682667 0.128-26.752-193.749333-0.597334z"
        fill="#333F48"
      ></path
    ></symbol>
    <symbol id="zw_icon-logo-dianjiang" viewBox="0 0 3072 1024"
      ><path
        d="M1231.786667 280.234667a18.602667 18.602667 0 0 1 3.712 2.389333c10.794667 9.130667 8.192 26.154667 8.106666 38.613333-0.256 141.013333-0.170667 282.026667-0.256 423.04 0 7.04-5.461333 5.973333-10.282666 3.413334l-37.12-19.541334c-2.56-1.408-5.290667-2.901333-6.826667-5.418666-5.290667-8.533333-1.408-30.677333-1.365333-40.32v-49.493334-98.986666l0.128-197.888c0-1.706667-0.085333-3.541333-1.408-4.650667-0.981333-0.853333-2.389333-0.853333-3.669334-0.853333H796.928c-1.92 0-2.858667 0.938667-2.901333 2.816-0.042667 1.493333-0.128 3.029333-0.128 4.565333 0 126.848 0 253.696 0.085333 380.586667 0 3.754667-1.194667 5.674667-4.608 7.381333-14.165333 6.997333-28.16 14.378667-42.154667 21.546667-1.962667 1.024-3.882667 2.133333-5.845333 3.072-1.792 0.896-2.816 0.341333-2.858667-1.706667l-0.042666-13.482667C738.432 651.605333 738.730667 567.765333 738.389333 483.925333 738.090667 424.106667 738.304 364.202667 738.133333 304.256 738.133333 299.178667 738.346667 294.058667 740.821333 289.28 746.026667 279.296 753.792 273.450667 765.141333 273.152 773.845333 273.066667 782.464 273.066667 791.125333 273.066667c117.845333 0 235.690667 0.554667 353.536 2.730666 13.44 0.213333 26.965333 0.298667 40.405334 0.853334 12.928 0.512 34.346667-2.816 46.72 3.584"
        fill="#000000"
      ></path
      ><path
        d="M1010.517333 462.805333c0-4.565333 0-9.088 1.066667-13.610666 2.602667-10.837333 14.293333-19.584 25.045333-19.712h134.272c0.512 0 0.981333-0.085333 1.493334 0 3.072 0 3.669333 0.64 3.626666 3.84l-0.128 14.677333v31.872c0 5.589333 0 5.589333-5.546666 5.589333h-100.096c-3.712 0-4.053333 0.426667-4.053334 4.096l0.042667 134.997334c0.042667 2.176-0.853333 3.584-2.901333 4.608-15.488 7.722667-30.933333 15.530667-46.464 23.253333-6.528 3.285333-6.4 3.242667-6.4-4.181333 0.042667-31.744 0.085333-155.392 0.042666-185.429334"
        fill="#000000"
      ></path
      ><path
        d="M1912.106667 287.146667C1912.106667 284.074667 1912.704 282.624 1916.245333 282.624 2030.208 282.709333 2297.344 282.624 2316.928 282.624c5.376 0 5.888 0.853333 4.650667 5.930667a292.266667 292.266667 0 0 0-6.528 29.696c-0.554667 3.882667-2.133333 5.205333-6.058667 5.205333C2289.024 323.285333 2056.789333 323.285333 1960.618667 323.242667c-5.930667 0-6.485333 0.426667-6.485334 5.461333C1954.218667 374.997333 1954.304 619.562667 1954.304 695.466667c0 4.608 0.426667 5.034667 4.864 5.034666l149.12-0.128 213.546667-0.170666c8.661333 0 8.917333 0.554667 6.741333 9.045333-2.261333 8.96-4.266667 18.005333-5.973333 27.093333-0.64 3.242667-2.005333 4.693333-5.12 4.693334l-402.218667 0.128c-2.389333 0.042667-3.242667-1.408-3.2-3.626667 0.042667-4.138667 0.085333-375.594667 0.042667-450.389333"
        fill="#000000"
      ></path
      ><path
        d="M2188.245333 461.098667h93.013334c4.650667 0 5.504 0.853333 4.48 5.333333-2.389333 10.752-4.949333 21.461333-7.296 32.213333-0.64 3.242667-2.688 3.370667-5.290667 3.370667l-31.232-0.128c-5.162667 0-5.589333 0.426667-5.589333 5.546667-0.042667 56.32 0.298667 173.098667 0.384 175.061333 0.128 2.688-0.938667 3.925333-3.882667 3.413333a1406.122667 1406.122667 0 0 0-32.725333-4.821333c-3.114667-0.426667-4.096-2.133333-4.096-5.12l0.128-149.888c0-6.613333-0.042667-13.312 0.085333-19.925333 0-2.986667-0.896-4.394667-4.053333-4.352-32.853333 0-65.536 0.085333-98.346667 0-3.626667 0-5.205333 1.706667-5.248 5.248-0.213333 20.053333-2.389333 40.064-4.693333 59.946666a349.184 349.184 0 0 1-14.165334 68.650667c-0.469333 1.450667-1.066667 2.816-1.578666 4.181333-3.029333 7.978667-3.029333 8.021333-11.52 8.064l-31.573334 0.085334c-3.328 0-4.266667-1.024-2.901333-3.712 8.277333-16.128 12.16-33.408 15.146667-51.2 4.906667-29.354667 7.253333-58.922667 9.130666-88.576 2.474667-41.728 2.090667-83.541333 1.450667-125.312a19.626667 19.626667 0 0 1 18.602667-20.608c7.381333-0.597333 14.805333-0.554667 22.186666-0.554667 31.402667-0.042667 62.848-0.085333 94.208 0 13.397333 0 26.837333 0.597333 40.277334-0.042667a320.042667 320.042667 0 0 0 45.525333-5.333333c4.565333-0.896 5.12-0.512 5.12 4.053333 0 10.410667-0.170667 20.864-0.085333 31.274667 0 3.413333-1.408 4.778667-4.693334 5.418667-18.901333 3.712-37.973333 5.376-57.173333 5.333333-39.296-0.128-78.592-0.128-117.888-0.341333-4.181333 0-4.522667 2.389333-4.522667 5.290666 0 4.224 0.512 8.533333 0.554667 12.8 0 13.226667 0.085333 26.581333-0.128 39.893334-0.042667 3.541333 0.853333 4.906667 4.650667 4.906666 31.232-0.128 62.506667-0.085333 93.738666-0.085333v-0.085333zM1655.381333 344.32H1503.573333c-6.101333 0-6.698667 0.512-6.4 6.656 1.92 38.912-0.256 77.781333-1.749333 116.650667a1232.768 1232.768 0 0 1-6.613333 84.010666 1149.312 1149.312 0 0 1-22.613334 136.661334c-3.456 15.104-7.253333 30.122667-11.392 45.056-2.474667 8.789333-2.304 8.789333-11.605333 8.789333h-29.354667c-4.906667 0-5.589333-0.853333-4.181333-5.546667 7.253333-24.746667 13.226667-49.792 18.346667-75.093333 5.205333-25.856 9.514667-51.925333 13.397333-78.08 3.242667-21.418667 5.418667-42.965333 7.68-64.512 2.133333-19.626667 3.968-39.253333 4.864-58.88 1.066667-22.442667 2.346667-44.842667 2.858667-67.328 0.426667-22.485333 0.341333-44.928-0.213334-67.413333a19.925333 19.925333 0 0 1 11.434667-19.541334c3.498667-1.792 7.253333-1.792 11.008-1.792 21.461333-0.128 42.965333-0.170667 64.426667-0.128 33.493333 0 66.986667 0 100.522666 0.085334 6.058667 0 6.186667-0.085333 5.930667-6.016-0.170667-4.010667-0.170667-8.021333-0.298667-12.074667-0.085333-2.261333 0.725333-3.498667 3.2-3.498667l37.632-0.128c3.114667 0 4.266667 1.365333 4.138667 4.394667-0.170667 4.394667 0.085333 8.789333-0.170667 13.184-0.256 3.541333 1.450667 4.266667 4.522667 4.181333 6.4-0.128 12.757333-0.085333 19.2-0.085333l96.768-0.170667c4.010667 0 4.864 0.725333 3.84 4.650667-2.773333 11.050667-4.309333 22.357333-6.698667 33.493333-0.512 2.346667-1.877333 2.645333-3.84 2.645334a2141.184 2141.184 0 0 0-16.512-0.085334h-136.32V344.32z"
        fill="#000000"
      ></path
      ><path
        d="M1652.352 372.394667c0-3.584 1.365333-4.693333 4.608-4.693334 10.922667 0.085333 21.845333 0.128 32.768 0 4.053333-0.085333 4.138667 2.517333 3.968 5.290667-0.554667 8.277333-0.384 16.512-0.341333 24.832 0.042667 10.197333 0.042667 10.069333 10.112 10.026667 28.757333-0.085333 57.514667 0 86.272 0l7.168-0.085334c2.645333 0 3.968 0.981333 3.242666 3.925334l-8.618666 34.218666c-0.384 1.578667-1.408 2.56-3.157334 2.688-2.133333 0.085333-4.266667 0.213333-6.4 0.213334-27.861333 0-55.765333-0.042667-83.626666-0.170667-3.498667-0.042667-4.864 1.109333-4.821334 4.693333 0.085333 19.370667-0.128 38.698667 0.085334 58.026667 0.042667 2.986667-0.938667 3.541333-3.285334 3.242667-8.362667-1.152-27.392-3.712-31.701333-4.352-4.138667-0.597333-5.973333-4.010667-5.973333-9.173334 0-18.986667-0.128-106.837333-0.298667-128.682666M1757.44 702.848c-24.96 0.042667-124.885333 0-149.845333 0.128-3.84 0-5.034667-1.237333-4.992-4.992v-120.832c0-4.778667-0.128-9.514667 0-14.293333 0.042667-4.864 1.365333-6.272 6.186666-6.656 2.346667-0.128 4.778667 0 7.168 0h140.8c6.912 0 8.533333 1.536 8.533334 8.661333l0.042666 130.645333c0 6.442667-0.853333 7.338667-7.893333 7.338667m27.477333-185.258667h-200.789333c-12.501333 0-20.565333 8.106667-20.565333 20.650667l-0.085334 197.717333c0 4.778667 0.682667 5.461333 4.992 5.461334 36.309333 0 206.122667 0.981333 216.576 0.554666a19.114667 19.114667 0 0 0 19.029334-19.882666l0.085333-184.917334a18.901333 18.901333 0 0 0-19.2-19.584"
        fill="#000000"
      ></path
    ></symbol>
    <symbol id="zw_icon-logo-ymx" viewBox="0 0 3072 1024"
      ><path
        d="M1818.581333 805.162667c-8.917333 8.96-17.834667 4.437333-13.354666-6.698667 13.354667-33.450667 44.586667-111.616 31.232-131.712-15.616-17.877333-98.261333-8.917333-133.973334-4.48-11.093333 2.261333-13.354667-8.917333-2.218666-15.616 66.986667-46.890667 174.165333-33.493333 187.52-17.834667 8.96 17.834667-6.698667 125.013333-69.205334 176.341334m-31.232-82.602667c-116.053333 84.864-281.301333 129.493333-426.453333 129.493333-200.917333 0-383.957333-73.685333-520.106667-198.698666-11.221333-8.917333 0-22.314667 11.136-15.616 147.328 87.04 332.672 138.410667 520.149334 138.410666 127.274667 0 267.946667-26.794667 397.397333-80.384 20.096-8.917333 35.754667 13.397333 17.92 26.794667"
        fill="#FF9900"
      ></path
      ><path
        d="M724.693333 517.205333c-8.96 17.834667-24.533333 26.752-42.410666 26.752-24.533333 0-37.973333-17.834667-37.973334-44.629333 0-51.328 46.890667-62.506667 91.562667-62.506667v13.397334c0 26.794667 2.218667 46.890667-11.178667 66.986666m120.533334 26.752c-11.178667-15.616-22.314667-29.013333-22.314667-55.808V392.192c0-40.192 2.218667-78.165333-26.752-104.96C771.584 264.917333 733.610667 256 704.597333 256 646.570667 256 581.802667 278.314667 566.186667 349.781333c-2.261333 8.917333 4.48 13.354667 8.917333 13.354667l60.288 6.698667c4.48 0 8.917333-6.698667 11.178667-11.136 4.437333-24.576 26.794667-35.712 49.066666-35.712 13.44 0 26.794667 4.437333 33.493334 15.616 8.96 13.397333 6.741333 29.013333 6.741333 44.629333v8.96c-35.712 4.437333-82.645333 6.698667-116.096 22.314667-37.973333 15.616-64.768 51.328-64.768 100.437333 0 62.549333 40.192 96 91.562667 96 44.629333 0 66.944-11.136 100.437333-44.629333 11.178667 15.616 15.658667 24.576 35.712 40.192 4.48 2.218667 11.178667 2.218667 13.44-2.218667 13.354667-11.178667 33.450667-31.274667 46.848-40.192 6.741333-6.741333 6.741333-13.397333 2.218667-20.138667m685.397333-26.752c-8.96 17.834667-24.576 26.752-42.410667 26.752-24.576 0-37.973333-17.834667-37.973333-44.629333 0-51.328 46.890667-62.506667 91.52-62.506667v13.397334c0 26.794667 0 46.890667-11.136 66.986666m120.576 26.752c-11.178667-15.616-22.357333-29.013333-22.357333-55.808V392.192c0-40.192 2.261333-78.165333-26.794667-104.96C1577.514667 264.917333 1539.584 256 1510.528 256c-58.026667 0-122.794667 22.314667-138.410667 93.781333-2.218667 6.656 4.437333 11.136 8.917334 13.354667l60.288 6.698667c6.698667 0 8.917333-6.698667 11.178666-11.136 4.437333-24.576 26.794667-35.712 49.066667-35.712 13.397333 0 26.837333 4.437333 33.536 15.616 8.917333 13.397333 6.656 29.013333 6.656 44.629333v8.96c-35.712 4.437333-82.56 6.698667-116.053333 22.314667-37.973333 13.397333-64.768 46.890667-64.768 96 0 62.506667 40.192 96 91.562666 96 44.629333 0 66.986667-11.178667 100.437334-44.672 11.178667 15.658667 15.616 24.576 35.712 40.192a13.653333 13.653333 0 0 0 15.616-2.218667c13.44-11.178667 33.493333-31.274667 46.933333-40.192 4.437333-2.261333 4.437333-8.917333 0-15.658667m888.533333-149.546666v198.698666c0 4.437333-6.698667 8.917333-11.178666 8.917334h-62.506667c-6.698667 0-11.178667-4.48-11.178667-8.917334V421.205333c0-33.493333 4.48-84.821333-37.973333-84.821333-15.573333 0-29.013333 8.917333-35.712 24.533333-8.96 20.096-8.96 37.973333-8.96 60.288v169.685334c0 6.656-4.394667 11.136-11.093333 11.136h-62.506667c-6.741333 0-11.178667-4.48-11.178667-11.136V276.096c0-6.698667 6.698667-11.178667 11.178667-11.178667h58.026667c4.48 0 8.917333 4.48 11.178666 8.917334V322.986667c17.834667-42.410667 42.410667-62.549333 84.821334-62.549334 26.794667 0 53.589333 8.96 71.466666 37.973334 15.616 24.576 15.616 66.986667 15.616 96M2102.144 543.957333c-49.109333 0-46.848-82.56-46.848-120.533333 0-37.930667 2.133333-100.437333 49.066667-100.437333 17.877333 2.218667 31.274667 8.917333 37.973333 31.232 8.96 24.576 8.96 55.808 8.96 82.602666 0 40.192-2.261333 107.136-49.152 107.136m0-283.52c-89.301333 0-138.410667 75.946667-138.410667 174.165334 0 98.218667 49.066667 174.122667 138.410667 174.122666 84.821333 0 140.629333-75.904 140.629333-171.904 0-98.218667-51.328-176.384-140.629333-176.384M1307.306667 392.192v198.698667c0 6.656-4.437333 11.136-11.093334 11.136h-62.549333c-6.741333 0-11.178667-4.48-11.178667-11.136V423.424c0-13.397333 2.261333-46.890667-2.218666-58.026667-4.437333-20.096-17.92-26.794667-35.712-26.794666-15.658667 0-31.274667 8.917333-35.754667 26.794666a278.528 278.528 0 0 0-6.698667 60.245334v167.466666c0 6.698667-4.437333 11.178667-11.136 11.178667h-60.288c-6.698667 0-11.136-4.48-11.136-11.178667V425.642667c0-35.712 6.698667-87.04-37.973333-87.04-44.629333 0-42.410667 51.328-42.410667 87.04v167.466666c0 6.698667-4.48 11.178667-11.178666 11.178667H905.514667c-6.698667 0-11.136-4.48-11.136-11.178667V278.314667c0-6.698667 4.437333-11.136 11.093333-11.136h58.112c6.698667 0 11.093333 4.437333 11.093333 11.136v40.192C990.421333 278.314667 1017.173333 260.437333 1055.146667 260.437333s62.506667 17.877333 80.384 58.069334C1151.104 278.314667 1184.554667 260.437333 1220.266667 260.437333c26.794667 0 53.589333 11.178667 71.424 33.536 20.138667 26.752 15.616 64.725333 15.616 98.218667M1932.501333 535.04v46.890667a12.202667 12.202667 0 0 1-15.658666 11.178666c-62.464-33.493333-145.109333-35.754667-214.314667 0-6.698667 4.437333-13.397333-4.48-13.397333-11.178666V537.301333c0-6.741333 0-20.096 6.698666-31.274666l120.576-174.122667h-104.96c-6.656 0-11.178667-4.48-11.178666-11.178667V276.096c0-6.698667 4.522667-11.178667 11.178666-11.178667h200.96c6.656 0 11.093333 4.48 11.093334 11.178667v37.930667c0 6.698667-4.437333 15.616-15.616 29.013333l-100.437334 149.589333c37.973333 0 80.384 4.48 116.053334 24.576 6.741333 4.437333 8.96 11.136 8.96 17.834667"
        fill="#000000"
      ></path
    ></symbol>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import path from "path"
import header from "@/assets/images/default/header.png"
import normal from "@/assets/images/user/normal.png"
import vip0 from "@/assets/images/user/vip0.png"
import vip1 from "@/assets/images/user/vip1.png"
import vip2 from "@/assets/images/user/vip2.png"
import vip3 from "@/assets/images/user/vip3.png"
import vip4 from "@/assets/images/user/vip4.png"
import vip5 from "@/assets/images/user/vip5.png"
import cart from "@/assets/images/user/shopping-cart.png"
import message from "@/assets/images/user/message.png"
import order from "@/assets/images/user/order.png"
import SvgIcon from "../common/SvgIcon.vue"
import LoginBar from "@/components/LoginBar"
import { getUserProfile } from "@/api/system/user"
import { getConfigKey } from "@/api/system/config"

export default {
  components: { SvgIcon, LoginBar },
  name: "sideBar",
  data() {
    this.onlyOneChild = null
    return {
      isShowPopov: true,
      ifHidBadge: true,
      hTime: 0,
      warehouse: [
        {
          Cggl: "商品管理",
          leafCggl: [
            { name: "商品管理", url: "/spgl" },
            { name: "仓库清单", url: "/ckqd" },
            { name: "商品配对", url: "/sppd" },
            { name: "仓库设置", url: "/cksz" },
          ],
        },
      ],
      auxiliaryFunction: [
        {
          Cggl: "辅助功能",
          leafCggl: [
            { name: "常见问题", url: "/cjwt" },
            { name: "公告管理", url: "/gggl" },
          ],
        },
      ],
      message: message,
      cart: cart,
      avator: header,
      vip0: vip0,
      vip1: vip1,
      vip2: vip2,
      vip3: vip3,
      vip4: vip4,
      vip5: vip5,
      normal: normal,
      user: {},
      designFlag: '', // 0显示两个按钮，1只显示旧，2只显示新
    }
  },
  computed: {
    ...mapGetters([
      "name",
      "nickName",
      "avatar",
      "permission_routes",
      "stat",
      // "user",
      "dictMap",
    ]),
    ...mapGetters({
      currentUser: 'user',
    }),
    menus() {
      if (this.permission_routes[0] && this.permission_routes[0].children) {
        const list = JSON.parse(JSON.stringify(this.permission_routes[0].children))
        const index_1 = list.findIndex(v => v.name == "Design")
        if (index_1>-1) {
          const index_2 = list[index_1].children.findIndex(v => v.name == "Online")
          if (index_2>-1) {
            const finalList = list[index_1].children[index_2].children
            let namesToRemove = []
            if (this.dictMap['design_test']?.[this.currentUser.primAcc.trim()]) {
              // 配置用户只显示新设计器
               namesToRemove = ['Tool', 'CreateBatch']
            } else {
              // 没配置用户按照designFlag配置条件显示
              if (this.designFlag == '1') { //旧
                namesToRemove = ['DesignerNew', 'CreateBatchNew', 'DesignerOther']
              } else if (this.designFlag == '2') { //新
                namesToRemove = ['Tool', 'CreateBatch']
              }
              // 剩下的都显示
            }
            const newArray = finalList.filter(item => !namesToRemove.includes(item.name))
            list[index_1].children[index_2].children = newArray
          }
        }
        return list
      }
    },
    getImage() {
      if (this.user.vipType == "0" || !this.user.vipType) {
        return vip0
      }  else if (this.user.vipType == "1") {
        return vip1
      } else if (this.user.vipType == "2") {
        return vip2
      } else if (this.user.vipType == "3") {
        return vip3
      } else if (this.user.vipType == "4") {
        return vip4
      } else if (this.user.vipType == "5") {
        return vip5
      }
    },
    loginLogoUrl() {
      return this.$store.state.setting.siteData.loginLogoUrl
    },
  },
  mounted() {
    this.getConfigDesignFlagKey()
    this.getUserProfile()
    this.events.$on("updateUser", this.getUserProfile)
  },
  methods: {
    async logout() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          location.href = "index"
        })
      })
    },
    handleCommand(val) {
      if (val == "0") {
        this.$router.push({ path: "/system/account/userInfo" })
      } else if (val == "1") {
        this.logout()
      }
    },
    topMenuClick(url) {
      if (url == "/index") {
        this.$router.push({ path: url })
      }
    },
    handleJump(path) {
      this.$router.push({
        path: path,
      })
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true }
        return true
      }

      return false
    },
    handleJumpMenu(menu) {
      if (menu.meta.title == "客服") {
        let url =
          "https://im.onecust.cn/#/chat/home?token=" +
          localStorage.getItem("token")
        window.open(url, "_blank")
      }
      if (menu.meta.title == "IP隔离") {
        let url = "https://www.superbrowser.com/?from=170345&utm_source=170345"
        window.open(url, "_blank")
      }
    },
    // 获取完整的路径（用于外部链接）
    getFullPath(...paths) {
      const resolvedPath = this.resolvePath(...paths)
      // 如果是外部链接，直接返回
      if (resolvedPath.startsWith('http')) {
        return resolvedPath
      }
      // 否则构建完整的URL
      const baseUrl = window.location.origin
      return `${baseUrl}${resolvedPath}`
    },
    resolvePath(firstPath, secondPath, thirdPath) {
      // if (isExternal(thirdPath)) {
      //     return thirdPath
      // }
      return path.resolve(firstPath, secondPath, thirdPath)
    },
    handleRefreshUser() {
      this.getUserProfile()
      // this.$refs["loginBar"].getUserProfile()
    },
    getUserProfile() {
      getUserProfile().then((res) => {
        this.user = res.user
      })
    },
    getConfigDesignFlagKey() {
      getConfigKey("design_flag").then(res => {
        if (res.code == 200) {
          this.designFlag = res.msg
        }
      })
    },
  },
}

window.setBackground = function(dom, color) {
  dom.style.backgroundColor = color
}
</script>

<style lang="scss" scoped>
.top_side_bar {
  display: block;
  width: 200px;
  float: left;
  margin: 7px 0 0;
}

a {
  text-decoration: none;
}

.top_side_bar img {
  display: block;
  margin: 4px 0 0 26px;
}

.menu {
  // display: inline-block;
  float: left;
  padding: 0 0 0 38px;
}

.menu .el-button {
  background: none !important;
  border: none !important;
  color: white !important;
  // font-size: 15px;
  font-size: 16px;
  font-weight: bold;
  // height: 50px;
  height: 60px;
  border-radius: 0;
  top: -1px;
  position: relative;
}

.menu_item {
  font-size: 13px;
  margin: 5px 0;
}

.el-button:focus,
.el-button:hover {
  background-color: rgba(255, 255, 255, 0.3) !important;
}

.child_menu .el-row {
  width: 100%;
  min-height: 50px;
}

.child_menu .el-col {
  width: 50%;
  display: flex;
}

.child_menu {
  width: 790px;
}

.el-popper {
  margin-top: 0px !important;
}

.plat-til {
  display: inline-block;
  margin: 10px 20px 0 0;
  border-radius: 2px;
  border: 1px solid #ebeef5;
  min-width: 64px;
  height: 22px;
  background: url(../../assets/images/navPlatformIcon.png?v=2) no-repeat;
}

.el-badge {
  padding: 5px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 2px;
}

.el-badge:hover {
  background-color: #337ab7;
  color: white;
}

.child_menu .el-row:first-child {
  border-bottom: 1px solid #ebeef5;
}

.tit-currency {
  background-position: 0 -11px;
}

.tit-wish {
  background-position: 0 -70px;
}

.tit-smt {
  background-position: 0 -128px;
}

.tit-ebay {
  background-position: 0 -189px;
}

.tit-amz {
  background-position: 0 -249px;
}

.tit-lzd {
  background-position: 0 -309px;
}

.tit-dh {
  background-position: 0 -369px;
}

.tit-shopify {
  background-position: 0 -429px;
}

.tit-shopee {
  background-position: 0 -490px;
}

.tit-joom {
  background-position: 0 -549px;
}

.tit-tophatter {
  background-position: 0 -610px;
}

.plat-cover {
  display: none;
}

.un_auth:hover .plat-cover {
  display: block;
  position: absolute;
  top: 0;
  right: auto;
  left: 0;
  bottom: auto;
  width: 100%;
  height: 100%;
  font-size: 20px;
  line-height: 70px;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
}

.plat-box {
  margin-top: 10px;
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
}

.menu_row {
  /*margin: 5px;*/
  display: flex;
  padding: 8px 4px 0 4px;
  /*margin-top: 15px;*/
  /* border-bottom: 1px dashed #ccc; */
}

.bottom_menu_row {
  margin: 5px;
  display: flex;
  border: none;
}

.menu_til {
  width: 80px;
  color: #434649;
  font-weight: 600;
}
.menu_til span {
  width: 74px;
  display: block;
}

.menu_leaf_body {
  width: 100%;
  height: auto;
  margin-left: 25px;
}

.leaf_menu {
  width: 25%;
  display: inline-block;
  margin-bottom: 10px;
  font-size: 13px;
}

.leaf_menu span {
  padding: 2px;
}

.leaf_menu span:hover {
  cursor: pointer;
  background-color: #4934b2;
  color: #ffffff;
  border-radius: 2px;
  padding: 2px;
}

.right-login-info {
  display: flex;
  float: right;
  // height: 50px;
  height: 60px;
  align-items: center;
  .cart {
    color: #ffffff;
    font-size: 26px;
    padding: 0px 16px 0 16px;
    cursor: pointer;
    position: relative;
  }
}

.right-login-info .info-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 10px;
}

.right-login-info .info-item .badge {
  position: relative;
  width: 18px;
  height: 18px;
  line-height: 18px;
  color: white;
  background-color: orange;
  border-radius: 9px;
  font-size: 12px;
  top: -15px;
  right: 10px;
}

.right-login-info .info-item img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  float: left;
}
.msg-sz,
.login-out-sz {
  width: 25px !important;
  height: 25px !important;
}
.badge-item {
  ::v-deep .el-badge__content.is-fixed {
    top: 12px;
  }
}
.cart-number {
  position: absolute;
  right: 0px;
  top: 4px;
  font-size: 12px;
  width: 17px;
  height: 17px;
  background: red;
  border-radius: 50%;
  text-align: center;
  color: #ffffff;
  line-height: 16px;
}
.vip0__style-3DnzZg {
  display: inline-block;
  width: 13px;
  height: 13px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABUUlEQVQokUWRsS5FQRCGZzk3BIlEr9dqPIbaEwjFVerxALdR6HgF8Qr0ElEoaTSX5CaX4Mz//zKzZznJZvfM7Df/P7Nl/0miZLkoA1WQOw3iLshrR8bNCXPyppNUSEsQotU9oTVI5wF4FoE59NFT466p1MpmQDvrxMlNNIAM+BTkcxfBastSKVRc2gZ5FBerLYXKo5OTiHUB+J8SI7kI8sKp7h+inDxwsg8nnUcfQ+MDHMmdCmSRgK4cvI27ESt791/moJqagzNQ6w5aX8E3J7ccnOYd0NJC+0mIXI+zN3XyGNC0mGlUiv2QpfubVp1OTi8br8AdqEsz6dtRwurq0kgLQ3JYbbS5eicP+5iEWS0kxNEGSOl/aDr6CrsTQA/hoEJ1kgmlNaCNtiVfnDoL5QaRdcrxdX30EQ86NJ8q4tipuceDU/b++VU2VpaTeJ3Nyy8qnu5f49Fu/gAAAABJRU5ErkJggg==);
}
.common-topbar-user-info {
  float: right;
  padding: 0;
  // height: 50px;
  box-sizing: border-box;
  position: relative;
  padding: 0 12px;
}

.common-topbar-user-info .common-topbar-user-image-wrapper {
  overflow: hidden;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.nav-bm-user-btn:hover .common-topbar-user-info-dropdown {
  display: block;
}
.common-topbar-user-info:hover {
  background: #8071c9;
}

.menu_til svg:hover {
  border-color: #4934b2;
}
.menu_til svg {
  width: 72px;
  height: 24px;
  border: 1px solid #e4e4e4;
  margin: -5px 0 0 0;
}
</style>
